import {Employee} from "./employee.entity";
import {Entity} from "./entity";
import {IssueStatus} from "./issue-status.entity";
import {IssueType} from "./issue-type.entity";
import {Keyword} from "./keyword.entity";
import {Project} from "./project.entity";

export class Filters extends Entity<Filters> {

    private _board: Project | null = null;

    public get board(): Project | null {
        return this._board;
    }

    public set board(value: Project | null) {
        this._board = value;
        this._setOriginalValue(`board`, value);
    }

    private _creator: Employee | null = null;

    public get creator(): Employee | null {
        return this._creator;
    }

    public set creator(value: Employee | null) {
        this._creator = value;
        this._setOriginalValue(`creator`, value);
    }

    private _assignees: Employee[] = [];

    public get assignees(): Employee[] {
        return this._assignees;
    }

    public set assignees(value: Employee[]) {
        this._assignees = value;
        this._setOriginalValue(`assignees`, value);
    }

    private _issueType: IssueType | null = null;

    public get issueType(): IssueType | null {
        return this._issueType;
    }

    public set issueType(value: IssueType | null) {
        this._issueType = value;
        this._setOriginalValue(`issueType`, value);
    }

    private _keywords: Keyword[] = [];

    public get keywords(): Keyword[] {
        return this._keywords;
    }

    public set keywords(value: Keyword[]) {
        this._keywords = value;
        this._setOriginalValue(`keywords`, value);
    }

    private _issueStatus: IssueStatus | null = null;

    public get issueStatus(): IssueStatus | null {
        return this._issueStatus;
    }

    public set issueStatus(value: IssueStatus | null) {
        this._issueStatus = value;
        this._setOriginalValue(`issueStatus`, value);
    }

    private _searchText: string | null = null;

    public get searchText(): string | null {
        return this._searchText;
    }

    public set searchText(value: string | null) {
        this._searchText = value;
        this._setOriginalValue(`searchText`, value);
    }

    public toString(): string {
        return this.uid;
    }
}